<div class="flex flex-col justify-center items-center w-full">
	<!-- Logo -->
	<div class="mx-auto">
		<ms-logo class="max-w-128"></ms-logo>
	</div>

	<!-- Title -->
	<div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight text-center">
		Página não encontrada!
	</div>
	<div class="flex justify-center mt-5 font-medium">
		<!-- Redirect countdown -->
		<ng-container *ngIf="scope.countdown > 0">
			Você será redirecionado em {{ scope.countdown | i18nPlural: scope.countdownMapping }}
		</ng-container>

		<!-- Redirect message -->
		<ng-container *ngIf="scope.countdown === 0">
			Agora você está sendo redirecionado!
		</ng-container>
	</div>

	<!-- Form footer -->
	<div class="mt-8 text-md font-medium text-secondary text-center"></div>
</div>
